<script>
export default {
	data() {
		return {
			banner: {
				active: false,
				message: "Banner message",
				action: "See pricing options",
				onaction: () => true
			}
		};
	},
	computed: {
		$_banner_active() {
			return this.banner.active;
		}
	},
	methods: {
		$_banner_show({ message, action, onaction }) {
			this.banner.message = message;
			this.banner.action = action;
			this.banner.onaction = onaction;
			this.banner.active = true;
		},
		$_banner_hide() {
			this.banner.active = false;
		}
	}
};
</script>